import opa from "./opa.js";
/**
 * @type {opa.loadPolicy}
 */
export const loadPolicy = opa.loadPolicy;
export default opa;
